<template>
  <div
    :id="`${source}_prospecting_analytics`"
    class="flex flex-col gap-2 pb-3"
    v-if="store.getters['analytics/getUsersList']"
  >
    <AnalyticsFilterComponent :allowed-filters="prospectingAllowedFilters" />
    <ProspectingAnalyticsGrid />
    <SalesActivity :type="analyticTypes.TABLE" />
    <SalesActivity :type="analyticTypes.CHART" />
  </div>
</template>

<script setup>
import store from "@/src/store/index.js";
import {
  analyticTypes,
  prospectingAllowedFilters,
} from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import SalesActivity from "@/src/views/analytics/v2/prospecting_analytics/SalesActivity.vue";
import ProspectingAnalyticsGrid from "@/src/views/analytics/v2/prospecting_analytics/ProspectingAnalyticsGrid.vue";

const props = defineProps({
  source: { type: String, required: true },
});
</script>
